import { Grid } from 'antd';
import { APP_NAME } from 'configs/AppConfig';
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import { useSelector } from 'react-redux';
import utils from 'utils';

const { useBreakpoint } = Grid;

export const Logo = ({ mobileLogo, logoType }) => {
	const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg');

	const navCollapsed = useSelector(state => state.theme.navCollapsed);
	const navType = useSelector(state => state.theme.navType);

	const getLogoWidthGutter = () => {
		const isNavTop = navType === NAV_TYPE_TOP ? true : false;
		if (isMobile && !mobileLogo) {
			return 0;
		}
		if (isNavTop) {
			return 'auto';
		}
		if (navCollapsed) {
			return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
		} else {
			return `${SIDE_NAV_WIDTH}px`;
		}
	};

	const getLogo = () => {
		if (logoType === 'light') {
			if (navCollapsed) {
				return '/img/asepsis-logo.png';
			}
			return '/img/asepsis-logo.png';
		}

		if (navCollapsed) {
			return '/img/asepsis-logo.png';
		}
		return '/img/asepsis-logo.png';
	};

	const getLogoDisplay = () => {
		if (isMobile && !mobileLogo) {
			return 'd-none';
		} else {
			return 'logo';
		}
	};

	return (
		<div className={getLogoDisplay()} style={{ width: `${getLogoWidthGutter()}` }}>
			<img
				src={getLogo()}
				style={{
					height: '50px',
					width: 'auto',
					maxWidth: '250px',
				}}
				alt={`${APP_NAME} logo`}
			/>
		</div>
	);
};

export default Logo;
